import {
    createStore
} from 'vuex';

// const apiUrl = 'http://localhost:8080'
const apiUrl = "https://digitalportfoliobackend.deno.dev";

export default createStore({
    state: {
        navbarHidden: false,
        projects: [],
		skills: []
    },
    getters: {},
    mutations: {
		setProjects(state, value){
			state.projects = value;
		},
		setAspirations(state, value){},
		setAbout(state, value){},
		setSkills(state, value){
			state.skills = value;
		}
	},
    actions: {
		async getData(context){
			let { 
				aspirations, 
				about, 
				projects,
				skills
			} = (await (await fetch(apiUrl)).json()).data;

			context.commit('setSkills', skills);
			context.commit('setProjects', projects);
		}
	},
    modules: {}
})